import React, { useState } from 'react';
import Lightbox from 'react-image-lightbox';
import { Magnifier } from "react-image-magnifiers";

//Import Custom Component
import Carousel from '../../../../features/carousel';

function HorizontalThumbnail ( props ) {
  const [ photoIndex, setPindex ] = useState( 0 );
  const [ open, setOpen ] = useState( false );
  const { addClass = '', dataProduct } = props;
  const images = dataProduct.product ? dataProduct.product.images : dataProduct.images;

  const openLightBox = () => {
    let index = document.querySelector( ".product-slider-container .owl-item.active" ).index();
    setPindex( index );
    setOpen( true );
  }

  return (
    <div className={ `product-single-gallery ${addClass}` }>
      <div className="skel-pro skel-magnifier"></div>
      <div className="product-slider-container product-item">
        <Carousel addClass="product-single-carousel">
          {
            (dataProduct.product && (dataProduct.product.product_video_link )) || (dataProduct && dataProduct.product_video_link) ? 
              <div className="product-item">
                <video width="100%" preload="metadata" controls>
                  <source src={dataProduct.product ? `${dataProduct.product.product_video_link}#t=0.1` : `${dataProduct.product_video_link}#t=0.1`} type="video/mp4" />
                  Your browser does not support the video tag.
                </video>
                {/* <iframe className="d-block w-100 h-100" src={dataProduct.product ? `${dataProduct.product.product_video_link}` : `${dataProduct.product_video_link}`} title="Buduj.pl" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe> */}
              </div>
          : '' }
          {
            dataProduct.product ? 
              dataProduct.product.images.map( ( image, index ) => (
                <div className="product-item" key={ "product-item" + index } onClick={ openLightBox } itemProp="image">
                  <Magnifier
                    imageSrc={ `https://d22u7e6casvzfe.cloudfront.net/uploads/products/full/${image.product_image}` }
                    imageAlt={dataProduct.product_variant_name}
                    mouseActivation="doubleClick"
                    touchActivation="doubleTap"
                    cursorStyleActive="zoom-in"
                    dragToMove={ false }
                    className="product-single-image"
                  />
                </div>
              ))
            : 
            dataProduct.images.map( ( image, index ) => (
              <div className="product-item" key={ "product-item" + index } onClick={ openLightBox } itemProp="image">
                <Magnifier
                  imageSrc={ `https://d22u7e6casvzfe.cloudfront.net/uploads/products/full/${image.product_image}` }
                  imageAlt={dataProduct.product_name}
                  mouseActivation="doubleClick"
                  touchActivation="doubleTap"
                  cursorStyleActive="zoom-in"
                />
              </div>
            ))
          }
        </Carousel>
        {/* {
          (dataProduct.product && dataProduct.product.product_video_link && !landing) || (dataProduct.product_video_link && !landing) ? 
            <button onClick={handleOpenVideo} className="youtube-button">
              <img src={`${process.env.PUBLIC_URL}/assets/images/icons/icon-youtube.svg`} alt="" />
            </button>
          : null
        } */}
      </div>

      {/* <div className="prod-thumbnail row owl-dots" id='carousel-quick-dots'>
        {
          dataProduct.product ?
            dataProduct.product.images.map( ( thumbnail, index ) => (
              <div className="col-3 owl-dot p-0" key={ "Owl-dot" + index }>
                <img src={ `https://d22u7e6casvzfe.cloudfront.net/uploads/products/full/${thumbnail.product_image}` } alt={dataProduct.product_variant_name} />
              </div>
            ))
          :
          dataProduct.images.map( ( thumbnail, index ) => (
            <div className="col-3 owl-dot p-0" key={ "Owl-dot" + index }>
              <img src={ `https://d22u7e6casvzfe.cloudfront.net/uploads/products/full/${thumbnail.product_image}` } alt={dataProduct.product_name} />
            </div>
          ))
        }
      </div> */}
      <div className="d-flex justify-content-center" id='dots-after-thumbnail'>
        {
          (dataProduct.product && dataProduct.product.product_video_link) || (dataProduct && dataProduct.product_video_link) ? 
            <div className="owl-after owl-dot" key="Owl-dot-video"></div>
        : '' }
        {
          dataProduct.product ?
            dataProduct.product.images.map( ( thumbnail, index ) => (
              <div className="owl-after owl-dot" key={ "Owl-dot" + index }></div>
            ))
          :
          dataProduct.images.map( ( thumbnail, index ) => (
            <div className="owl-after owl-dot" key={ "Owl-dot" + index }></div>
          ))
        }
      </div>
      {
        open && (
          <Lightbox
            mainSrc={ `https://d22u7e6casvzfe.cloudfront.net/uploads/products/full/${images[(dataProduct.product && dataProduct.product.product_video_link) || (dataProduct && dataProduct.product_video_link) ? photoIndex - 1 : photoIndex].product_image}` }
            nextSrc={ `https://d22u7e6casvzfe.cloudfront.net/uploads/products/full/${images[ ( photoIndex + 1 ) % images.length ].product_image}` }
            prevSrc={ `https://d22u7e6casvzfe.cloudfront.net/uploads/products/full/${images[ ( photoIndex + images.length - 1 ) % images.length ].product_image}` }
            onCloseRequest={ () => setOpen( false ) }
            onMovePrevRequest={ () =>
              setPindex( ( photoIndex + images.length - 1 ) % images.length )
            }
            onMoveNextRequest={ () =>
              setPindex( ( photoIndex + 1 ) % images.length )
            }
          />
        )
      }
    </div>
  )
}

export default HorizontalThumbnail;